"use strict";

var React = require("react");
module.exports = React.createElement(
  "svg",
  { viewBox: "0 0 36 36" },
  React.createElement("path", { d: "M19.011 20.333v-2.084a1.442 1.442 0 0 1 .367-.93 11 11 0 0 0 2.5-6.866c0-5.2-2.756-8.1-6.919-8.1s-7 3.018-7 8.1a11.121 11.121 0 0 0 2.622 6.865 1.442 1.442 0 0 1 .367.93v2.074A1.431 1.431 0 0 1 9.7 21.768C1.338 22.5.031 28.218.031 30.474c0 .251.03 3.237.048 3.484h29.842s.026-3.234.026-3.484c0-2.163-1.478-7.864-9.691-8.7a1.437 1.437 0 0 1-1.245-1.441z" }),
  React.createElement("path", { d: "M27.374 19.534a1.342 1.342 0 0 1-1.16-1.346v-1.013a1.531 1.531 0 0 1 .342-.867 12.144 12.144 0 0 0 1.869-6.4c0-4.354-2.57-7.552-6.452-7.552-.232 0-.445.042-.668.062a10.931 10.931 0 0 1 2.974 8.037 13.46 13.46 0 0 1-2.869 8.171v.874c8.622 1.281 10.936 7.667 10.936 10.972 0 .108 0 .768-.01 1.484h3.586s.024-3.15.024-3.384a9.564 9.564 0 0 0-8.572-9.038z" })
);

